<template>
    <main class="register-confirm">
        <div class="container">
            <Header
                v-if="user.client_type == ESSENTIAL"
                :title="`¡Bienvenido ${user.first_name}!`"
                text="Agenda tu reunión de Kick-Off, conecta tu SII."
            />
            <Header
                v-if="user.client_type == BASIC"
                :title="`¡Bienvenido ${user.first_name}!`"
                text="Conecta tu SII."
            />
            <FillData />
        </div>
    </main>
</template>

<script>
import FillData from "@/components/fillData/FillData";
import Header from "@/components/signupAndLogin/Header";
import { BASIC, ESSENTIAL } from "@/utils/clientTypes";
import { mapState } from "vuex";

export default {
    name: "filldata",
    components: {
        Header,
        FillData,
    },
    data() {
        return {
            ESSENTIAL,
            BASIC,
        };
    },
    computed: {
        ...mapState("userAuth", ["user"]),
    },
};
</script>
